<template>
  <main class="sa-content">
    <div v-if="loading">
      <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader" />
    </div>
    <div class="sa-card-large sa-accounts" v-else>
      <h5 class="sa-card-tit sa-h-xs">Accounts</h5>
      <div class="sa-mob-header sa-h-sm-up sa-header1">
           <h5 class="sa-card-tit">Accounts</h5>
           <button class="sa-btn-back" @click="$router.go(-1)">
             <i class="icon-left-arrow"></i>
           </button>
          </div>
      <div class="sa-mob-cont sa-row sa-mt20">
        <div class="sa-col-xs12 sa-col-sm12 sa-col-md8 sa-col-lg6">
          <form>
            <span class="sa-blue-text">Last Settlement Date</span>
            <div class="sa-row sa-mt20">
              <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6">
                <div class="sa-form-group">
                  <label>Date</label>
                  <input disabled type="text" class="sa-line-input" v-model="bankdetails.LAST_SETTLEMENT_DATE" id="settlementDate" name="Last Settlement Date" />
                </div>
              </div>
              <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6">
                <div class="sa-form-group">
                  <label>Amount</label>
                  <input disabled type="text" class="sa-line-input" v-model="bankdetails.LAST_SETTLEMENT_AMOUNT" id="amount" name="Amount" />
                </div>
              </div>
            </div>
            <span class="sa-blue-text sa-mt20">Next Schedule Settlement Date</span>
            <div class="sa-row sa-mt20">
              <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6">
                <div class="sa-form-group">
                  <label>Date</label>
                  <input disabled type="text" class="sa-line-input" v-model="bankdetails.NEXT_SETTLEMENT_DATE" id="scheduleDate" name="Next Schedule Settlement Date" />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <span class="sa-blue-text sa-mt20">Account Details</span>
      <div class="sa-card sa-card-noshadow sa-accounts-card">
        <div class="sa-row">
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md3 sa-col-lg3">
            <label>Name as mentioned in bank</label>
            {{bankdetails.unme}}
          </div>
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md3 sa-col-lg3">
            <label>Bank Name</label>
            {{bankdetails.bank_nm}}
          </div>
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md3 sa-col-lg3">
            <label>I BAN number</label>
            {{bankdetails.iban}}
          </div>
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md3 sa-col-lg3">
            <label>Account number</label>
            {{bankdetails.ac_no}}
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { pro_url } from "../../../config/endpoints";
export default {
  components: {},
  data() {
    return {
      bankdetails: {
        unme: "",
        bank_nm: "",
        iban: "",
        ac_no: "",
        LAST_SETTLEMENT_DATE: "",
        LAST_SETTLEMENT_AMOUNT: "",
        NEXT_SETTLEMENT_DATE: ""
      },
      loading:false
    };
  },
  methods: {
    getBankdetails() {
      let _self = this;
      _self.loading = true;
      let res = _self.$store
        .dispatch("httpGet", {
          uri: `${pro_url}/getSettlements`
        })
        .then(response => {
          if (response.status === 1000) {
            _self.bankdetails = response.data;
          } else {
          }
          _self.loading = false;
        });
    },
   
  },

  created() {
    let _self = this;
    _self.getBankdetails();
  }
};
</script>
